<!-- Template from page -->
<template>
  <section class="height-top">
    <div class="col-md-12 height-top padding-null signin">

      <div class="content-info">
        <h1 class="nunito">MarQ.</h1>
        <img src="src/assets/img/login/ImagemLogin.png" alt="imagem" class="img-responsive"/>
      </div>
      <div class="col-md-4 height-top form-login right-content">

        <div class="content-login">
          <img src="src/assets/img/logo-yellow.png" class="img-responsive logo" alt="Logo"/>

          <p class="nunito type">Administrativo</p>

          <h2 class="certa">Login</h2>

          <form @submit.prevent="login">
            <div class="form-input">
              <valid-field :v="$v.email" :b-invalid="false" :b-success="false">
                <div class="padding-null group-icon">
                  <img src="src/assets/img/login/user.png" class="img-responsive icon-img" alt="usuário"/>
                  <input v-model="email" @blur="$v.email.$touch()" type="text" name="email" placeholder="E-mail"
                         required autocomplete="off"/>
                </div>
              </valid-field>
            </div>

            <div class="form-input">
              <valid-field :v="$v.password" :b-invalid="false" :b-success="false">
                <div class="padding-null group-icon">
                  <img src="src/assets/img/login/lock.png" class="img-responsive icon-img" alt="usuário"/>
                  <input v-model="password" @blur="$v.password.$touch()" type="password" name="password"
                         placeholder="Password" required autocomplete="off"/>
                </div>
              </valid-field>
            </div>

            <div class="content-btn">
              <span class="span"></span><span class="span2"></span>
              <button type="submit" :disabled="loading" v-bind:class="{'disable': loading}" class="certa">
                <div v-if="loading" class="loading-btn-login">
                  <div class="spinner-btn-login">
                    <div class="rect1"></div>
                    <div class="rect2"></div>
                    <div class="rect3"></div>
                    <div class="rect4"></div>
                    <div class="rect5"></div>
                  </div>
                </div>
                <span v-else>Entrar</span>
              </button>
            </div>
          </form>
        </div>

      </div>
    </div>
  </section>
</template>

<!-- Script from page -->

<script>
import {
  LOGIN,
  USER_ACCESS
} from "../../../../urlConfig";

import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../utils";

import {
  required,
  minLength
} from 'vuelidate/lib/validators'

import validField from "../../components/default/validField.vue";
import swal from 'sweetalert';

export default {
  name: 'login',
  components: {
    validField
  },
  data() {
    return {
      loading: false,
      email: '',
      password: '',
      browserId: ''
    }
  },
  methods: {
    access() {
      REQUEST_SERVICE.get(USER_ACCESS).then((response) => {
        window.localStorage.setItem('mamUserMasterInfo', JSON.stringify(response.data));
        this.loading = true;

        // Redirect user.
        this.$router.push({
          path: '/dashboard'
        });

      }).catch((reason) => {
        this.loading = false;

        swal("Aviso", reason, "error");
      });
    },
    login() {
      if (this.$v.email.$invalid || this.$v.password.$invalid) {
        this.$v.$touch();
      } else {
        this.loading = true;

        REQUEST_SERVICE.login(LOGIN, {
          password: this.password,
          email: this.email
        })
          .then((response) => {
            let authUser = {};

            authUser.isAuth = true;
            authUser.userToken = response.data.access_token;
            authUser.userTokenType = response.data.token_type;
            authUser.userContentSetting = response.data.contentsetting;
            // Cross token (GUID) que a API v2 troca por JWT; ver broadcastApiV2Auth.js.
            authUser.crossToken = response.data.token;

            window.localStorage.setItem('marQAdminAuthUser', JSON.stringify(authUser));

            this.access();
          })
          .catch((reason) => {
            swal("Aviso", reason.response.data.error_description, "error");
            this.loading = false;
          });
      }
    },
  },
  validations: {
    email: {
      required
    },
    password: {
      required,
      minLength: minLength(6)
    },
  },
  beforeMount() {
    if (this.browserId === null) {
      this.browserId = UTIL_SERVICE.randomToken();
      window.localStorage.setItem('browserId', JSON.stringify(this.browserId));
    }
  }
}
</script>

<!-- Style from page -->

<style lang="scss">
// Login
.signin {
  height: 100%;
  width: 100%;
  position: fixed;
  background-image: linear-gradient(#17066d, #ffda2f);
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;

  .content-info {
    position: absolute;
    left: 5%;

    h1 {
      color: #F2F5F9;
      font-size: 26px;
      line-height: 35px;
      font-weight: normal;
      width: 60%;
      display: block;
      margin: 10% auto;
      padding: 0 59px;
      text-align: center;
    }

    img {
      width: 60%;
      display: block;
      margin: 0 auto;
    }

    @media only screen and (max-device-width: 1024px) {
      left: -2%;
    }
  }

  .right-content {
    //background-color: rgba(0, 9, 22, 0.8);
    background-color: #ffffff;
    height: 100%;
    float: right;
    overflow-y: auto;
    overflow-x: hidden;

    .content-login {
      width: 80%;
      display: block;
      margin: 0 auto;

      .logo {
        width: 80%;
        display: block;
        margin: 30% 0 0;
      }

      .type {
        color: #191919;
        margin-top: 5px;
        text-align: left;
        font-size: 13px;
      }

      h2 {
        font-size: 26px;
        color: #191919;
        text-align: left;
        margin-top: 10%;
      }

      h3 {
        font-size: 18px;
        color: #191919;
        text-align: left;
        margin-top: 10%;
      }

      .form-input {
        position: relative;
        width: 100%;
        min-height: 42px;
        margin-top: 20px;
        margin-bottom: 20px;

        .field-txt-invalid {
          font-size: 11px;
        }

        .group-icon {
          .icon-img {
            position: absolute;
            top: 11px;
            left: 9px;
            width: 6%;

            @media only screen and (max-device-width: 1024px) {
              top: 13px;
            }

            @media only screen and (max-device-width: 768px) {
              top: 12px;
              width: 3%;
            }

            @media only screen and (max-device-width: 430px) {
              top: 13px;
              width: 6%;
            }
          }

          input {
            width: 100%;
            height: 42px;
            border-radius: 8px;
            padding-left: 38px;
            padding-right: 15px;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0.5px;
            float: left;
            border: none;
            background: #F2F5F9;
            -webkit-transition: color .25s linear, background-color .25s ease-in-out, border-color .25s ease-in-out, filter .25s linear, opacity .25s ease-in-out;
            -moz-transition: color .25s linear, background-color .25s ease-in-out, border-color .25s ease-in-out, filter .25s linear, opacity .25s ease-in-out;
            -o-transition: color .25s linear, background-color .25s ease-in-out, border-color .25s ease-in-out, filter .25s linear, opacity .25s ease-in-out;
            transition: color .25s linear, background-color .25s ease-in-out, border-color .25s ease-in-out, filter .25s linear, opacity .25s ease-in-out;

            &:hover,
            &:focus,
            &:active {
              border: solid 1px #c1c7ce;
            }
          }
        }
      }

      .lost-password {
        height: 15px;

        a {
          color: #352DA5;
          float: right;
          padding-right: 5px;
          font-size: 13px;
          cursor: pointer;

          &:hover {
            color: #1d167f;
            padding-bottom: 2px;
            border-bottom: 1px solid #1d167f;
            text-decoration: none;
          }
        }
      }

      .content-btn {
        position: relative;
        margin-top: 10%;

        .span {
          background: #FDD944;
          height: 26px;
          position: absolute;
          width: 50%;
          top: 36px;
          right: -15px;
        }

        .span2 {
          height: 26px;
          position: absolute;
          width: 50%;
          top: 36px;
          right: -15px;
          background: linear-gradient(to right, #352DA5, #352DA5);
          background-repeat: no-repeat;
          background-size: 0 100%;
          transition: background-size 1s 0s;
        }

        button {
          width: 50%;
          height: 45px;
          background: transparent;
          cursor: pointer;
          position: relative;
          border: 2px solid #352DA5;
          color: #352DA5;
          font-size: 19px;
          float: right;
        }

        &:hover {
          .span2 {
            background-size: 100% 100%;
          }

          button {
            border: 2px solid #1A0F6B;
            color: #1A0F6B;
          }
        }

        @media only screen and (max-device-width: 414px) {
          .span {
            width: 100%;
          }

          button {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/public/login/Login.vue